import { render, staticRenderFns } from "./DepartmentUserCreate.vue?vue&type=template&id=6ee9296a&scoped=true"
import script from "./DepartmentUserCreate.vue?vue&type=script&lang=js"
export * from "./DepartmentUserCreate.vue?vue&type=script&lang=js"
import style0 from "./DepartmentUserCreate.vue?vue&type=style&index=0&id=6ee9296a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee9296a",
  null
  
)

export default component.exports